import { render, staticRenderFns } from "./BusinessCustomer.vue?vue&type=template&id=68cc16bf"
import script from "./BusinessCustomer.vue?vue&type=script&lang=ts"
export * from "./BusinessCustomer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports